<template>
  <div class="lejiale-container">
    <el-config-provider :locale="locale">
      <router-view />
    </el-config-provider>
  </div>
</template>

<script setup lang="ts">
import zhCn from 'element-plus/dist/locale/zh-cn'
const locale = zhCn
</script>
<style lang="scss" scoped>
@import './App.scss';
</style>
